import { pipe } from 'ramda';
import { StateStatus } from '@alycecom/utils';

import { IRootState } from '../../../../store/root.types';

const pathToMeetingState = (state: IRootState) => state.recipient.meeting;

export const getIsPending = pipe(pathToMeetingState, state => state.status === StateStatus.Pending);
export const getIsFulfilled = pipe(pathToMeetingState, state => state.status === StateStatus.Fulfilled);

export const getSlots = pipe(pathToMeetingState, state => state.slots);

export const getErrors = pipe(pathToMeetingState, state => state.errors);

export const getWeek = pipe(pathToMeetingState, ({ from, to }) => ({ from, to }));

export const getAutoDetect = pipe(pathToMeetingState, state => state.autoDetect);
